import {createSelector} from 'reselect'
import {selectUserPanel} from "../selector"
import {createGroupComparator} from "../../../util/groupUtils"
import {getUserGroupsWithDefault} from "../../../entities/selectors"
import GroupType from "../../../enums/GroupType"
import {isLoading as isEditPanelLoading, isPanelOpened as isEditPanelOpened, isUpdatingData as isUserEditPanelDataUpdating} from "../editPanel/selectors"
import {getFullUserInfo} from "../userData/selectors"
import User from '../../../store/User'
import {userComparator} from '../../../usersSelector/user_group_selector_util'

const getUserManagementCommonState = (state) => state.userManagement.common

//TODO better use selector getUsersList from userManagement/common, but this module imported in it, think about better way for getEditingUserId selector
const getUsersMap = createSelector(
    getUserManagementCommonState,
    (commonState) => commonState.usersList
)

export const selectUserData = createSelector(
    selectUserPanel,
    (userPanel) => userPanel.userData
)

export const isEditUserPanelOpened = state => isEditPanelOpened(state)
export const isLoading = state => isEditPanelLoading(state)
export const isUpdatingData = state => isUserEditPanelDataUpdating(state)

const getTeamAssignmentsData = createSelector(
    selectUserData,
    userData => userData.userTeamAssignmentsData
)

export const getAssignedUserIds = createSelector(
    getTeamAssignmentsData,
    teamAssignmentsData => teamAssignmentsData.assignedUsers
)

export const getAssignedGroupIds = createSelector(
    getTeamAssignmentsData,
    teamAssignmentsData => teamAssignmentsData.assignedGroups
)

export const getTeamAssignmentType = createSelector(
    getTeamAssignmentsData,
    teamAssignmentsData => teamAssignmentsData.teamAssignmentType
)

export const getUserGroups = createSelector(
    getUserGroupsWithDefault,
    userGroupsWithDefault => Object.values(userGroupsWithDefault).sort(createGroupComparator(GroupType.USER_GROUP))
)

export const getUsers = createSelector(
    getUsersMap,
    (users) => {
        return Object.values(users).map((user) => {
            return new User(
                user["id"],
                user["firstName"],
                user["lastName"],
                user["middleInitial"],
                user["username"],
                user["activeInAT"] || user["enabled"],
                false,
                user["userGroupId"],
                user["timeZoneGroupId"]
            )
        }).sort(userComparator)
    }
)

export const getUserFML = createSelector(
    getFullUserInfo,
    (fullUserInfo) => fullUserInfo ? {
        firstName: fullUserInfo.firstName,
        middleInitial: fullUserInfo.middleInitial,
        lastName: fullUserInfo.lastName,
    } : {}
)



// WEBPACK FOOTER //
// ./web/js/panels/user/teamAssignmentsPanel/selectors.js